import React, { useState } from 'react'
import { Modal, Button, FormGroup, FormControl } from 'react-bootstrap'
import { useForm, Controller, SubmitHandler } from 'react-hook-form'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { AbsoluteLoading, RoundedModal } from '../../../../generic'
import { createBarrierTypeConfig, createBarrierType } from '../../../../services'
import { IDiagram, IAsset, IBarrierType } from '../../../../types'

type IProps = {
    show: boolean
    handleClose: () => void
    handleSave: (id: number) => void
    item?: IBarrierType /* item will be the same listItem change it when back ready */
}
interface IFormData {
    name: string
    description: string
    iconReference: string
}

const formDefault: IFormData = {
    name: null,
    description: null,
    iconReference: ''
}

export const AddBarrierCategoriesModal: React.FC<IProps> = ({ handleClose, handleSave, show, item = [] }) => {
    const { handleSubmit, control, formState, setValue, watch } = useForm<IFormData>({
        mode: 'all',
        defaultValues: formDefault
    })

    const [inLoadingCreate, setInLoadingCreate] = useState(false)
    const [inLoading, setInLoading] = useState(false)

    const handleCloseProtocol = (): void => {
        setValue('name', null)
        setValue('description', null)
        setInLoadingCreate(false)

        handleClose()
    }

    const handleCreate: SubmitHandler<IFormData> = async (data): Promise<void> => {
        try {
            await createBarrierType(data).then(response => {
                handleCloseProtocol()
                handleSave(response.id)
            })
        } catch (error) {
            globalNotification.error(error.message ?? i18n('An error occurred on save Barrier Category.'))
        }
    }

    return (
        <RoundedModal show={show} onHide={handleCloseProtocol} aria-labelledby="contained-modal-title">
            <form onSubmit={handleSubmit(handleCreate)}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">{i18n('New Category')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Controller
                        rules={{ required: true }}
                        name="name"
                        control={control}
                        render={({ field, fieldState }) => (
                            <FormGroup validationState={fieldState.error ? 'error' : 'success'}>
                                <label className="control-label">{i18n('Name')}</label>
                                <FormControl
                                    type="text"
                                    ref={field.ref}
                                    onChange={field.onChange}
                                    onBlur={field.onBlur}
                                    value={field.value}
                                />
                            </FormGroup>
                        )}
                    />
                    <Controller
                        rules={{ required: true }}
                        name="description"
                        control={control}
                        render={({ field, fieldState }) => (
                            <FormGroup validationState={fieldState.error ? 'error' : 'success'}>
                                <label className="control-label">{i18n('Description')}</label>
                                <FormControl
                                    className="text-area-form-group"
                                    type="text"
                                    ref={field.ref}
                                    onChange={field.onChange}
                                    onBlur={field.onBlur}
                                    value={field.value}
                                    componentClass="textarea"
                                    style={{ height: 117, maxHeight: 117, minHeight: 117 }}
                                />
                            </FormGroup>
                        )}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button className="no-outline-button" bsStyle="primary" type="submit" disabled={!formState.isValid}>
                        {inLoadingCreate ? (
                            <>
                                <i className="fa fa-spinner fa-spin" /> {i18n('Creating')}
                            </>
                        ) : (
                            i18n('Create')
                        )}
                    </Button>
                    <Button className="no-outline-button" type="button" onClick={handleCloseProtocol}>
                        {i18n('Cancel')}
                    </Button>
                </Modal.Footer>
                <AbsoluteLoading show={inLoading || inLoadingCreate} />
            </form>
        </RoundedModal>
    )
}
